import React from 'react';

export const ControlBar = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 106.9 69.3" {...props}>
      <path fill="#fff" d="M5.6.8h95.8v67.8H5.6z" />
      <path
        d="M101.3 69.3H5.6c-.4 0-.8-.3-.8-.8V.8c0-.5.3-.8.8-.8h95.8c.4 0 .8.3.8.8v67.8c-.1.4-.4.7-.9.7zM6.4 67.8h94.2V1.6H6.4v66.2z"
        fill="#dcd9d5"
      />
      <path fill="#fff" d="M5.6.8h95.8v67.8H5.6z" />
      <path
        d="M101.3 69.3H5.6c-.4 0-.8-.3-.8-.8V.8c0-.5.3-.8.8-.8h95.8c.4 0 .8.3.8.8v67.8c-.1.4-.4.7-.9.7zM6.4 67.8h94.2V1.6H6.4v66.2z"
        fill="#dcd9d5"
      />
      <g fill="#dcd9d5">
        <path d="M10 5.3h86.8v58.8H10z" />
        <path d="M96.9 64.9H10c-.4 0-.8-.3-.8-.8V5.3c0-.4.3-.8.8-.8h86.8c.4 0 .8.3.8.8v58.8c.1.4-.3.8-.7.8zm-86.1-1.6h85.3V6H10.8v57.3z" />
      </g>
      <path
        d="M106.2 69.3H.7c-.4 0-.7-.3-.7-.7 0-.4.3-.7.7-.7h105.4c.4 0 .7.3.7.7.1.4-.2.7-.6.7z"
        fill="#dcd9d5"
      />
      <g>
        <path fill="#233762" d="M6.1 1.5h46.6v66H6.1z" />
        <path
          d="M53.6 68.4H5.3V.7h48.3v67.7zM6.9 66.7h45V2.4h-45v64.3z"
          fill="#fff"
        />
        <path fill="#233762" d="M11.1 8.5h37v4.8h-37z" />
        <path
          d="M48.5 13.7H10.6V8.1h37.8v5.6zm-37-.9h36.1V8.9H11.5v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M11.1 13.3h37v4.8h-37z" />
        <path
          d="M48.5 18.4H10.6v-5.6h37.8v5.6zm-37-.8h36.1v-3.9H11.5v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M11.1 18h37v4.8h-37z" />
        <path
          d="M48.5 23.2H10.6v-5.6h37.8v5.6zm-37-.9h36.1v-3.9H11.5v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M11.1 22.8h37v4.8h-37z" />
        <path
          d="M48.5 28H10.6v-5.6h37.8V28zm-37-.9h36.1v-3.9H11.5v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M11.1 27.5h37v4.8h-37z" />
        <path
          d="M48.5 32.7H10.6v-5.6h37.8v5.6zm-37-.8h36.1V28H11.5v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M11.1 32.3h37v4.8h-37z" />
        <path
          d="M48.5 37.5H10.6v-5.6h37.8v5.6zm-37-.9h36.1v-3.9H11.5v3.9z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M11.1 37h37v4.8h-37z" />
          <path
            d="M48.5 42.2H10.6v-5.6h37.8v5.6zm-37-.8h36.1v-3.9H11.5v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M11.1 41.8h37v4.8h-37z" />
          <path
            d="M48.5 47H10.6v-5.6h37.8V47zm-37-.9h36.1v-3.9H11.5v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M11.1 46.6h37v4.8h-37z" />
          <path
            d="M48.5 51.7H10.6v-5.6h37.8v5.6zm-37-.8h36.1V47H11.5v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M11.1 51.3h37v4.8h-37z" />
          <path
            d="M48.5 56.5H10.6v-5.6h37.8v5.6zm-37-.8h36.1v-3.9H11.5v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M11.1 56.1h37v4.8h-37z" />
          <path
            d="M48.5 61.3H10.6v-5.6h37.8v5.6zm-37-.9h36.1v-3.9H11.5v3.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M28.5 8.5h2.4v52.3h-2.4z" />
      </g>
      <g>
        <path fill="#233762" d="M53.5 1.5h46.6v66H53.5z" />
        <path
          d="M100.9 68.4H52.6V.7h48.3v67.7zm-46.6-1.7h45V2.4h-45v64.3z"
          fill="#fff"
        />
        <path fill="#233762" d="M58.4 8.5h37v4.8h-37z" />
        <path
          d="M95.8 13.7H58V8.1h37.8v5.6zm-36.9-.9H95V8.9H58.9v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M58.4 13.3h37v4.8h-37z" />
        <path
          d="M95.8 18.4H58v-5.6h37.8v5.6zm-36.9-.8H95v-3.9H58.9v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M58.4 18h37v4.8h-37z" />
        <path
          d="M95.8 23.2H58v-5.6h37.8v5.6zm-36.9-.9H95v-3.9H58.9v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M58.4 22.8h37v4.8h-37z" />
        <path
          d="M95.8 28H58v-5.6h37.8V28zm-36.9-.9H95v-3.9H58.9v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M58.4 27.5h37v4.8h-37z" />
        <path
          d="M95.8 32.7H58v-5.6h37.8v5.6zm-36.9-.8H95V28H58.9v3.9z"
          fill="#fff"
        />
        <path fill="#233762" d="M58.4 32.3h37v4.8h-37z" />
        <path
          d="M95.8 37.5H58v-5.6h37.8v5.6zm-36.9-.9H95v-3.9H58.9v3.9z"
          fill="#fff"
        />
        <g>
          <path fill="#233762" d="M58.4 37h37v4.8h-37z" />
          <path
            d="M95.8 42.2H58v-5.6h37.8v5.6zm-36.9-.8H95v-3.9H58.9v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M58.4 41.8h37v4.8h-37z" />
          <path
            d="M95.8 47H58v-5.6h37.8V47zm-36.9-.9H95v-3.9H58.9v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M58.4 46.6h37v4.8h-37z" />
          <path
            d="M95.8 51.7H58v-5.6h37.8v5.6zm-36.9-.8H95V47H58.9v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M58.4 51.3h37v4.8h-37z" />
          <path
            d="M95.8 56.5H58v-5.6h37.8v5.6zm-36.9-.8H95v-3.9H58.9v3.9z"
            fill="#fff"
          />
        </g>
        <g>
          <path fill="#233762" d="M58.4 56.1h37v4.8h-37z" />
          <path
            d="M95.8 61.3H58v-5.6h37.8v5.6zm-36.9-.9H95v-3.9H58.9v3.9z"
            fill="#fff"
          />
        </g>
        <path fill="#fff" d="M75.9 8.5h2.4v52.3h-2.4z" />
      </g>
    </svg>
  );
};
